<template>
  <section class="layout-section -bg-shade">
    <article v-scroll:reveal="{ delay: 75 }" class="publication-single__body -bg-white">
      <div v-scroll:reveal="{ delay: 150 }" class="rte" v-html="wp.content" />
    </article>
  </section>
</template>

<script>
export default {
  name: 'ResourcesNcfContent',
  inject: ['wp']
}
</script>
